import { render, staticRenderFns } from "./HeaderBoxCasamento.vue?vue&type=template&id=82a8d72c&"
import script from "./HeaderBoxCasamento.vue?vue&type=script&lang=js&"
export * from "./HeaderBoxCasamento.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBoxCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports